import { getCookie, setCookie } from 'cookies-next'
import type { NextApiRequestCookies } from 'next/dist/server/api-utils'
import type { IncomingMessage, ServerResponse } from 'node:http'
// I have no idea why but eslint can't find uuid even if it is there
// eslint-disable-next-line import/named
import { v4 as uuidv4 } from 'uuid'

import { APP_ENV, SPLIT_IO_SERVER_API_KEY } from '@/config/env'
import { cookieNames } from '@helpers/cookies/utils'
import { SplitFactory } from '@splitsoftware/splitio'
import type SplitIO from '@splitsoftware/splitio/types/splitio'

import * as RUMService from './RUM'

let client: SplitIO.IClient

export const getSplitClient = () => {
  if (!client) {
    const splitApiKey = SPLIT_IO_SERVER_API_KEY

    const factory = SplitFactory({
      core: {
        authorizationKey:
          APP_ENV === 'testing' || APP_ENV === 'development' ? 'localhost' : splitApiKey,
      },
      features: './.split',
      impressionListener: {
        logImpression: (impressionData) => {
          RUMService.addFeatureFlagEvaluation(
            impressionData.impression.feature,
            impressionData.impression.treatment
          )
        },
      },
    })
    client = factory.client()
  }
  return client
}

export const getSplitUserKey = (params?: {
  req: IncomingMessage & { cookies: NextApiRequestCookies }
  res: ServerResponse<IncomingMessage>
}) => {
  // browser_id is a necessary cookie
  // with current implementation it is not possible to get object with consent
  // since this function is called on the server side
  const userKey = getCookie(cookieNames.browser_id, params)
  const anonymousId = getCookie(cookieNames.anonymous_id, params)

  if (typeof anonymousId === 'string' && anonymousId !== '') {
    if (userKey !== anonymousId) {
      setCookie(cookieNames.browser_id, anonymousId, params)
    }
    return anonymousId
  }

  if (typeof userKey === 'string' && userKey !== '') {
    return userKey
  }

  const newKey = uuidv4()
  setCookie(cookieNames.browser_id, newKey, params)
  setCookie(cookieNames.anonymous_id, newKey, params)

  return newKey
}
